export default "__VITE_ASSET__Ccg64_oa__"